<template>

  <div>

      <div class="mb-2 pa-2" style="border-radius: 4px; background-color: #FAFAFA;">

        <v-row>

          <v-col cols="2">

            <v-select
              :items="operators"
              :value="term.operator"
              @input="onSelectOperator"
              item-text="label"
              item-value="name"
              label="Operator"
              />
          </v-col>

          <v-col>
            <v-select
              :items="scopes"
              :value="term.scope"
              @input="onSelectScope"
              item-text="name"
              item-value="name"
              label="Scope"
              />
          </v-col>

          <v-col>

            <template v-if="term.scope == 'value'">

              <v-text-field :value="term.value" @input="onSelectValue" label="Value" />

            </template>

            <template v-else-if="term.scope == 'constants'">

              <v-select
                :items="scopes.find(s => s.name == term.scope).attributes"
                :value="term.field"
                @input="onSelectField"
                item-text="name"
                item-value="id"
                :label="term.scope"
              />

            </template>

            <template v-else-if="term.scope == 'Stage Input'">

            </template>

            <template v-else>

              <v-select
                v-if="term.scope != null"
                :items="scopes.find(s => s.name == term.scope).attributes"
                :value="term.field"
                @input="onSelectField"
                item-text="name"
                item-value="name"
                :label="term.scope"
              />

            </template>

          </v-col>

          <v-col cols="auto" style="position:relative;">
            <v-btn title="delete" style="position: absolute; right: 0; top: 8px;" text plain x-small @click="$emit('deleteExprBlock', termIndex)">
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </v-col>


        </v-row>

      </div>

  </div>

</template>


<script>

export default {

  components: {

  },

  props: {

    scopes: {
      type: Array,
      default: []
    },

    operators: {
      type: Array,
      default: [],
    },

    term: {
      scope: null,
      value: null,
      field: null,
      operator: 'default'
    },

    termIndex: {
      type: Number,
    }

  },

  data() {

    return {

    }

  },

  created() {

  },

  watch: {

  },

  computed: {


  },

  methods: {

    onSelectOperator(val) {

      this.$emit('operator', val);

    },

    onSelectScope(val) {

      if(val == 'Stage Input') {
        this.$emit('field', null);
      }

      this.$emit('scope', val);

    },

    onSelectValue(val) {
      this.$emit('field', null);
      this.$emit('value', val);
    },

    onSelectField(val) {
      this.$emit('field', val);
    }

  }
}
</script>


<style lang="scss">


</style>
